import { Component } from '@theme/component';
class AuraGiftFinder extends Component {
  #controller;
  connectedCallback() {
    super.connectedCallback();
    this.#controller?.abort();
    this.#controller = new AbortController();
    const controls = this.querySelector('[data-aura-filters]');
    if (controls) controls.hidden = false;
    this.addEventListener('click', this.#select, { signal: this.#controller.signal });
  }
  #select = (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('button[data-aura-filter]');
    if (!button || !this.contains(button)) return;
    const value = button.dataset.auraFilter;
    for (const option of this.querySelectorAll('[data-aura-filter]')) option.setAttribute('aria-pressed', String(option === button));
    let count = 0;
    for (const card of this.querySelectorAll('[data-aura-category]')) {
      card.hidden = value !== 'all' && card.dataset.auraCategory !== value;
      if (!card.hidden) count++;
    }
    const status = this.querySelector('[data-aura-filter-status]');
    if (status) status.textContent = `${button.textContent.trim()} · ${count}`;
  };
  disconnectedCallback() {
    this.#controller?.abort();
    super.disconnectedCallback();
  }
}
if (!customElements.get('aura-gift-finder')) customElements.define('aura-gift-finder', AuraGiftFinder);
